import { Layers } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";

export * from "./api";
export { FloorEditor, FloorBreakdown, cleanFloorInputs, emptyFloorInputs } from "./FloorEditor";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const OffersPage = lazyPage(() => import("./OffersPage"), "OffersPage");

export default defineModuleUi({
  key: "offers",
  title: "Ofertas e preços",
  domain: "commercial",
  icon: Layers,
  menu: [{ path: "/comercial/ofertas", label: "Ofertas e preços", minRole: "member", icon: Layers, order: 40, keywords: "escada piso preço custo papel fundador" }],
  routes: [{ path: "/comercial/ofertas", element: <OffersPage />, minRole: "member" }],
});
